var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82 1.17L11.457 7.797C12.108 8.725 11.444 10 10.311 10L1.689 10C0.556002 10 -0.107997 8.725 0.542003 7.797L5.181 1.17C5.27322 1.03837 5.39581 0.930912 5.53837 0.856721C5.68094 0.78253 5.83929 0.743793 6 0.743793C6.16072 0.743793 6.31907 0.78253 6.46163 0.856721C6.6042 0.930913 6.72779 1.03837 6.82 1.17Z",
    fill: "#089D49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.a184586da73ee055e7a7144c5ffceb7c.svg";
export { ForwardRef as ReactComponent };